<template>
<div>  
    <b-table class="RouteTable"
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :filter-function="filterMethod"
        :per-page="perPage"
        :current-page="currentPage">
    </b-table>
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
  
</div>    
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import timetable from '@/store/timetable/timetable'

export default {
    name: 'routeListTable',
    components: { TablePagination },
    props: {
        filter: {default: null}
    },
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            filteredRows: 0,
            fields: [
                { key:"tunnus" , label: this.$t('route_view.id'), sortable: true },
                { key:"nimi" , label: this.$t('route_view.name'), sortable: true },
                { key:"destinations" , label: this.$t('route_view.destinations'),
                 formatter: (value, key, item) => {
                     var dest = "";
                     var language = 1; //Määränpäät ykköskielellä reittilistauksessa

                     for( var a of item.destinations ) {
                        if( dest.length === 0 && a.kielikoodi === language ) {
                            dest = a.nimi;
                            if( a.kautta )
                                dest += ' - ' + a.jarjestys + ' ' + a.kautta; 
                        } else if ( a.kautta && ( a.kielikoodi === language ))
                            dest += ' - ' + a.jarjestys + ' ' + a.kautta;
                     }
                     return dest;
                } }
            ],
        }
    },
    computed: {
        items () { 
            return this.$store.state.timetable.routes.list;
        },       
        totalRows() {
            return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
        }               
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.$store.dispatch('timetable/getRoutesWithDestinations');       
    },
    methods: {
        onRowSelected (items) {
            this.$emit('selectItem', items[0]);                 
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page;
        },
        filterMethod(item , filter) {
            if(!filter || (!filter.line && !filter.input)){
                //both line and input are null
                return true
            }
            if(filter.line && filter.line.id && filter.input){
                //both line and input are not null
                var inputLowerCase = filter.input.toLowerCase()
                var lineLowerCase = filter.line.id.toLowerCase()

                return (item.linja && item.linja.toLowerCase().includes(lineLowerCase)) &&
                ((item.nimi && item.nimi.toLowerCase().includes(inputLowerCase)) ||
                (item.tunnus && item.tunnus.toLowerCase().includes(inputLowerCase)) ||
                (item.destinations && item.destinations[0] && item.destinations[0].nimi && item.destinations[0].nimi.toLowerCase().includes(inputLowerCase))) 
            }
            var filterLowerCase
            if(filter.line && filter.line.id){
                //line is not null and input is null
                filterLowerCase = filter.line.id.toLowerCase()
                return (item.linja && item.linja.toLowerCase().includes(filterLowerCase)) 
            }
            if(filter.input){
                //input is not null and line is null
                filterLowerCase = filter.input.toLowerCase()
                return (item.nimi && item.nimi.toLowerCase().includes(filterLowerCase)) || 
                (item.tunnus && item.tunnus.toLowerCase().includes(filterLowerCase)) ||
                (item.destinations && item.destinations[0] && item.destinations[0].nimi && item.destinations[0].nimi.toLowerCase().includes(filterLowerCase))
            }

            


    }
    }
}

</script>

<style scoped lang="scss"> 

.RouteTable {
  display: inline-block;
  height: 45em;
  overflow:scroll;

}

</style> 
